import Cookies, { CookieAttributes } from 'js-cookie';
import sites, { Site } from 'framework/sites';

const COOKIE_COUNTRY_NAME = 'GEO_COUNTRY_2024_04';
const COOKIE_INTEND_URI = 'GEO_INTEND_2024_04';
const COOKIE_SETTINGS = <CookieAttributes>{
  domain: 'rains.com',
  expires: 30,
};

const EU_COUNTRIES = [
  'at',
  'be',
  'bg',
  'cy',
  'cz',
  'de',
  'dk',
  'ee',
  'es',
  'fi',
  'fr',
  'gr',
  'gb',
  'hu',
  'hr',
  'ie',
  'it',
  'lt',
  'lu',
  'lv',
  'mt',
  'pl',
  'pt',
  'nl',
  'ro',
  'se',
  'si',
  'sk',
  'cn',
  'us',
];

export const getUserCountry = async (): Promise<string> => {
  const countryCookie = Cookies.get(COOKIE_COUNTRY_NAME);

  if (countryCookie) {
    return countryCookie;
  }

  const response = await fetch('https://get.geojs.io/v1/ip/country.json');
  const body = await response.json();

  Cookies.set(COOKIE_COUNTRY_NAME, body.country.toLowerCase(), COOKIE_SETTINGS);

  return body.country.toLowerCase();
};

export const getSiteByCountry = (country: string) => sites.find((site) => site.region === country);

export const getSiteByUri = (uri: string) => {
  const result = sites.find((site) => {
    if ('uri' in site) {
      return site.uri === uri;
    }

    return site.languages.some((language) => language.uri === uri);
  });

  if (result) {
    return result;
  }

  throw new Error('Could not find current site');
};

export const getIntendedSite = (country: string) => {
  const uri = Cookies.get(COOKIE_INTEND_URI);
  let match: Site | null;

  if (uri) {
    match = getSiteByUri(uri);
  } else {
    match = getSiteByCountry(country);
  }

  if (match) {
    return match;
  }

  // Return default
  return sites.find((site) => site.default);
};

export const getCurrentUri = () =>
  theme.routes.root === '/' ? Shopify.shop : `${Shopify.shop}${theme.routes.root}`;

export const getCurrentSite = () => {
  const matchUri = getCurrentUri();

  return getSiteByUri(matchUri);
};

export const isOnIntendedSite = () => Cookies.get(COOKIE_INTEND_URI) === getCurrentUri();

export const setIntendUri = (uri: string) => {
  Cookies.set(COOKIE_INTEND_URI, uri, COOKIE_SETTINGS);
};

export const hasSelectedSite = () => !!Cookies.get(COOKIE_INTEND_URI);

export const getIntendUri = () => {
  const uri = Cookies.get(COOKIE_INTEND_URI);

  if (uri) {
    const isValidSite = sites.some((site) => {
      if ('uri' in site) {
        return site.uri === uri;
      }

      return site.languages.some((language) => language.uri === uri);
    });

    if (isValidSite) {
      return uri;
    }
  }

  return null;
};

export const shouldAutoRedirect = (userCountry: string) =>
  Cookies.get(COOKIE_INTEND_URI) || !EU_COUNTRIES.includes(userCountry);
